<template>
  <div class="" v-if="invoice">
    <TopBarTitleComponent title="Información Factura" :showBackIcon="true">
      <template slot="right-area">
        <div
          class="d-flex justify-content-center justify-content-md-end align-items-center"
        >
          <button
            v-if="invoice.enable_reminders !== undefined"
            class="topbar-action-btn"
            :class="{
              'topbar-action-btn--reminder-on': invoice.enable_reminders
            }"
            :title="
              invoice.enable_reminders
                ? 'Pausar recordatorios'
                : 'Activar recordatorios'
            "
            @click="toggleReminders(!invoice.enable_reminders)"
          >
            <i class="el-icon-bell"></i>
          </button>
          <button
            class="topbar-action-btn"
            @click="handleCommand('invoice-send')"
            title="Enviar documento"
          >
            <i class="el-icon-s-promotion"></i>
          </button>
          <button
            class="topbar-action-btn"
            @click="handleCommand('invoice-download')"
            title="Descargar PDF"
          >
            <i class="el-icon-download"></i>
          </button>
          <el-dropdown
            @command="handleCommand"
            class="d-flex align-items-center mr-3"
          >
            <button class="topbar-action-btn">
              <i class="el-icon-more"></i>
            </button>
            <el-dropdown-menu slot="dropdown">
              <template
                v-if="invoice.status === 'draft' || invoice.status === 'failed'"
              >
                <el-dropdown-item command="invoice-edit"
                  ><img :src="iconEdit" alt="" /> Editar</el-dropdown-item
                >
              </template>
              <el-dropdown-item command="invoice-add-payment">
                <i class="el-icon-money" style="margin-right:6px"></i> Agregar
                pago
              </el-dropdown-item>
              <el-dropdown-item command="invoice-edit-payments">
                <i class="el-icon-edit-outline" style="margin-right:6px"></i>
                Editar pagos
              </el-dropdown-item>
              <el-dropdown-item command="invoice-paid"
                ><img :src="iconCheck" alt="" /> {{ textOptionIsPaid }} como
                pagada</el-dropdown-item
              >
              <el-dropdown-item command="invoice-print"
                ><img :src="iconDownload" alt="" /> Vista de
                impresión</el-dropdown-item
              >
              <el-dropdown-item command="invoice-history-email">
                <img :src="iconHistory" alt="" /> Historial
                envio</el-dropdown-item
              >
              <template v-if="invoice.status === 'success'">
                <el-dropdown-item command="invoice-nuled"
                  ><img :src="iconNuled" alt="" /> Anular
                  factura</el-dropdown-item
                >
              </template>
              <el-dropdown-item
                v-if="invoice.status === 'nuled'"
                command="invoice-reactivate"
              >
                <i class="el-icon-refresh-right"></i> Reactivar factura
              </el-dropdown-item>
              <el-dropdown-item
                v-if="
                  invoice.status !== 'success' && invoice.status !== 'nuled'
                "
                command="invoice-delete"
              >
                <img :src="iconDelete" alt="" /> Eliminar
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <ButtonPrimaryComponent
            v-if="invoice.status !== 'success' && invoice.status !== 'nuled'"
            title="Firmar"
            @onSaveClick="toogleModalInvoiceSRI"
          />
        </div>
      </template>
    </TopBarTitleComponent>
    <b-container fluid class="pb-4 px-lg-4 pt-4">
      <b-row v-if="invoice.sri_sign_message">
        <b-col>
          <AlertInfoComponent
            title="Notificación SRI"
            type="error"
            class="mb-4"
            :description="invoice.sri_sign_message"
          />
        </b-col>
      </b-row>
      <b-row v-if="invoice">
        <b-col>
          <InvoiceTimeline :invoiceId="invoice.id" class="mb-3" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card box-shadow card-quotes-view py-4">
            <div class="card-body">
              <div class="card-quotes-view-header">
                <!-- Mobile header (oculto en desktop) -->
                <DocumentViewHeader
                  class="d-block d-md-none"
                  doc-type="Factura"
                  :doc-number="invoice.number_invoice"
                  :business="{
                    logo: getUser.user_business.business_logo,
                    name: getUser.user_business.social_reason,
                    ruc: getUser.user_business.business_ruc
                  }"
                  :date="invoice.emission_date_for_view"
                  :status="invoice.status"
                  :client="{
                    name: invoice.client.name,
                    document: invoice.client.document,
                    email: invoice.client.email
                  }"
                  :access-key="invoice.access_key"
                  :sign-mode="invoice.sign_mode"
                  :meta-items="[
                    {
                      label: 'Punto de emisión',
                      value: invoice.user_business_e_point_id
                        ? invoice.emission_point.code
                        : null
                    },
                    {
                      label: 'Forma de pago',
                      value: invoice.sri_forms_payment
                        ? invoice.sri_forms_payment.title
                        : null
                    }
                  ]"
                />

                <!-- Desktop header (oculto en mobile) -->
                <div class="d-none d-md-block dvh-desktop">
                  <div class="dvh-desktop-top">
                    <div class="dvh-desktop-identity">
                      <div class="dvh-desktop-logo">
                        <business-logo />
                      </div>
                      <div class="dvh-desktop-identity-info">
                        <p class="dvh-desktop-doc-number">
                          N°&nbsp;{{ invoice.number_invoice }}
                        </p>
                        <p class="dvh-desktop-business-name">
                          {{ getUser.user_business.social_reason }}
                        </p>
                        <p class="dvh-desktop-business-detail">
                          RUC: {{ getUser.user_business.business_ruc }}
                        </p>
                        <p class="dvh-desktop-business-detail">
                          {{ getUser.user_business.business_address }}
                        </p>
                      </div>
                    </div>
                    <div v-if="invoice.access_key" class="dvh-desktop-sri-col">
                      <p class="dvh-desktop-sri-title">
                        Autorización SRI
                      </p>
                      <div v-if="invoice.sign_mode" class="dvh-desktop-sri-row">
                        <span class="dvh-desktop-label">Ambiente</span>
                        <span
                          :class="[
                            'dvh-desktop-sri-env',
                            invoice.sign_mode === 2 ? 'env-prod' : 'env-dev'
                          ]"
                        >
                          {{
                            invoice.sign_mode === 2
                              ? "Producción"
                              : "Desarrollo"
                          }}
                        </span>
                      </div>
                      <div class="dvh-desktop-sri-row">
                        <span class="dvh-desktop-label">
                          Número / Clave de acceso
                        </span>
                        <span class="dvh-desktop-sri-code">
                          {{ invoice.access_key }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="dvh-desktop-divider"></div>

                  <div class="dvh-desktop-meta-grid">
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Fecha de emisión</span>
                      <span class="dvh-desktop-value">
                        {{ invoice.emission_date_for_view }}
                      </span>
                    </div>
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Punto de emisión</span>
                      <span
                        class="dvh-desktop-value"
                        v-if="invoice.user_business_e_point_id"
                      >
                        {{ invoice.emission_point.code }}
                      </span>
                    </div>
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Estado</span>
                      <StatusReadDocumentsComponent
                        :status.sync="invoice.status"
                      />
                    </div>
                    <div
                      class="dvh-desktop-meta-cell"
                      v-if="invoice.sri_forms_payment"
                    >
                      <span class="dvh-desktop-label">Forma de pago</span>
                      <span class="dvh-desktop-value">
                        {{ invoice.sri_forms_payment.title }}
                      </span>
                    </div>
                  </div>

                  <div class="dvh-desktop-divider"></div>

                  <div class="dvh-desktop-meta-grid">
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Cliente</span>
                      <span class="dvh-desktop-value">
                        {{ invoice.client.name }}
                      </span>
                    </div>
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Documento</span>
                      <span class="dvh-desktop-value">
                        {{ invoice.client.document }}
                      </span>
                    </div>
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Correo</span>
                      <span class="dvh-desktop-value">
                        {{ invoice.client.email }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-quotes-view-body mt-5">
                <div class="card-quotes-view-body-products">
                  <!-- Desktop: tabla con columnas (oculto en mobile) -->
                  <div class="d-none d-md-block">
                    <div class="card-quotes-view-table table-items">
                      <b-row class="table-items-header">
                        <b-col md="1">
                          <h6 class="h6 font-bold mb-0 ml-2">Código</h6>
                        </b-col>
                        <b-col md="5">
                          <h6 class="h6 font-bold mb-0">Detalle</h6>
                        </b-col>
                        <b-col md="2">
                          <h6 class="h6 font-bold mb-0">Cantidad</h6>
                        </b-col>
                        <b-col md="2">
                          <h6 class="h6 font-bold mb-0">Precio U.</h6>
                        </b-col>
                        <b-col md="2">
                          <h6 class="h6 font-bold mb-0">Subtotal</h6>
                        </b-col>
                      </b-row>
                    </div>
                    <b-row
                      class="mt-4 d-flex"
                      v-for="(product, index) in invoice.products"
                      :key="'d' + index"
                    >
                      <b-col md="1">
                        <p class="m-0 ml-2">
                          {{ product.product_code || product.product.code }}
                        </p>
                      </b-col>
                      <b-col md="5">
                        <p class="m-0">
                          <strong>{{ product.product.name }}</strong>
                          <span
                            v-if="product.product_detail"
                            v-html="product.product_detail"
                            class="text-pre-wrap d-block mt-1 text-muted"
                          ></span>
                        </p>
                      </b-col>
                      <b-col md="2">
                        <p class="m-0">{{ product.product_quantity }}</p>
                      </b-col>
                      <b-col md="2">
                        <p class="m-0">${{ product.product_amount }}</p>
                      </b-col>
                      <b-col md="2">
                        <p class="m-0">
                          ${{
                            handleCalculateSubTotal(
                              product.product_quantity,
                              product.product_amount
                            )
                          }}
                        </p>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- Mobile: tarjetas por ítem -->
                  <div class="d-block d-md-none doc-mobile-items">
                    <div
                      v-for="(product, index) in invoice.products"
                      :key="'m' + index"
                      class="doc-item"
                    >
                      <div class="doc-item-row">
                        <span class="doc-item-name">{{
                          product.product.name
                        }}</span>
                        <span class="doc-item-total">
                          ${{
                            handleCalculateSubTotal(
                              product.product_quantity,
                              product.product_amount
                            )
                          }}
                        </span>
                      </div>
                      <div v-if="product.product.code" class="doc-item-sku">
                        SKU: {{ product.product.code }}
                      </div>
                      <div class="doc-item-qty">
                        Cant: {{ product.product_quantity }} × ${{
                          product.product_amount
                        }}
                      </div>
                      <div
                        v-if="product.product_detail"
                        v-html="product.product_detail"
                        class="doc-item-detail text-pre-wrap"
                      ></div>
                    </div>
                  </div>
                </div>

                <!-- Mobile: totals + payment compact (antes del hr) -->
                <div class="d-block d-md-none">
                  <DocumentCalculator
                    readOnly
                    :setProducts="invoice.products"
                    :setDisc="invoice.discount"
                    :setServ="invoice.service"
                  />
                  <div class="doc-payment">
                    <span class="doc-payment-label">Forma de pago</span>
                    <span class="doc-payment-value">{{
                      humanizePaymentForm(invoice.sri_forms_payment.title)
                    }}</span>
                  </div>
                  <div v-if="invoice.method_payment === 2" class="doc-payment">
                    <span class="doc-payment-label">Tipo de pago</span>
                    <span class="doc-payment-value"
                      >Crédito<template v-if="getLimitCredit">
                        — {{ getLimitCredit.label }} vence
                        {{ invoice.limit_credit_at }}</template
                      ></span
                    >
                  </div>
                  <div
                    v-else-if="invoice.method_payment === 3"
                    class="doc-payment"
                  >
                    <span class="doc-payment-label">Tipo de pago</span>
                    <span class="doc-payment-value"
                      >Anticipo / Contra entrega</span
                    >
                  </div>
                  <div
                    v-if="
                      invoice.enable_reminders &&
                        !invoice.is_paid &&
                        invoice.status !== 'nuled'
                    "
                    class="doc-payment"
                  >
                    <span class="doc-payment-label">Recordatorio de cobro</span>
                    <span class="doc-payment-value reminder-next-text">
                      <i class="el-icon-bell"></i>
                      {{ reminderDetailText }}
                    </span>
                  </div>
                </div>

                <hr class="d-none d-md-block" />
                <!-- Desktop: full payment + totals layout -->
                <b-row class="d-none d-md-flex">
                  <b-col xs="12" sm="12" md="6">
                    <h5 class="h5 font-semi-bold d-block mb-2">
                      Forma de pago
                    </h5>
                    <p class="m-0" style="text-transform: capitalize;">
                      {{ humanizePaymentForm(invoice.sri_forms_payment.title) }}
                    </p>

                    <div
                      v-if="
                        invoice.additional_extras &&
                          invoice.additional_extras.length
                      "
                      class="mt-4"
                    >
                      <h5 class="h5 font-semi-bold d-block mb-2">
                        Información adicional
                      </h5>
                      <b-row
                        v-for="(additional, index) in invoice.additional_extras"
                        :key="index"
                      >
                        <b-col>{{
                          `${additional.name} - ${additional.description}`
                        }}</b-col>
                      </b-row>
                    </div>

                    <div class="mt-4">
                      <h5 class="h5 font-semi-bold d-block mb-2">
                        Tipo de pago
                      </h5>
                      <p class="m-0" v-if="invoice.method_payment === 1">
                        De contado
                      </p>
                      <div v-if="invoice.method_payment === 2">
                        <p class="m-0">Crédito</p>
                        <p class="m-0 text-muted" v-if="getLimitCredit">
                          {{ getLimitCredit.label }} vence
                          {{ invoice.limit_credit_at }}
                        </p>
                      </div>
                      <div v-if="invoice.method_payment === 3">
                        <p class="m-0 mb-2">Anticipo / Contra entrega</p>
                        <p
                          class="m-0 text-muted mb-3"
                          v-if="invoice.observation_advance"
                        >
                          {{ invoice.observation_advance }}
                        </p>
                        <div
                          v-if="installments.length"
                          class="installments-view"
                        >
                          <div
                            v-for="inst in installments"
                            :key="inst.id"
                            :class="[
                              'inst-view-row',
                              { 'inst-paid': inst.status === 'paid' }
                            ]"
                          >
                            <div class="inst-view-info">
                              <span class="inst-view-label">{{
                                inst.label
                              }}</span>
                              <span class="inst-view-pct"
                                >{{ inst.percentage }}%</span
                              >
                            </div>
                            <div class="inst-view-amount">
                              ${{ Number(inst.amount || 0).toFixed(2) }}
                            </div>
                            <span
                              :class="[
                                'inst-view-status',
                                inst.status === 'paid'
                                  ? 'status-paid'
                                  : 'status-pending'
                              ]"
                            >
                              {{
                                inst.status === "paid" ? "Pagada" : "Pendiente"
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        invoice.enable_reminders &&
                          !invoice.is_paid &&
                          invoice.status !== 'nuled'
                      "
                      class="mt-4"
                    >
                      <h5 class="h5 font-semi-bold d-block mb-2">
                        Recordatorio de cobro
                      </h5>
                      <p class="m-0 reminder-next-text">
                        <i class="el-icon-bell" style="margin-right: 4px;"></i>
                        {{ reminderDetailText }}
                      </p>
                    </div>
                  </b-col>
                  <b-col xs="12" sm="12" md="4" offset-md="2">
                    <DocumentCalculator
                      readOnly
                      :setProducts="invoice.products"
                      :setDisc="invoice.discount"
                      :setServ="invoice.service"
                    />
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <el-dialog :visible.sync="invoicePrint">
      <div class="d-flex justify-content-center">
        <print-invoice :invoice="invoice" id="printInvoice" />
      </div>
      <div class="d-flex justify-content-center align-items-center mt-5">
        <button type="button" class="btn md__btn-primary mr-4" @click="print">
          Imprimir
        </button>
      </div>
    </el-dialog>

    <SigningConfirmModal
      :visible.sync="invoiceSRIOuterVisible"
      :documentNumber="invoice ? invoice.number_invoice : ''"
      :clientName="invoice && invoice.client ? invoice.client.name : ''"
      :amount="invoice ? invoice.total : 0"
      @confirm="sendInvoiceSRI"
    />

    <el-dialog
      width="35%"
      title=""
      :visible.sync="invoiceNuledOuterVisible"
      class=""
    >
      <div class="wrapper__invoice-nuled text-center">
        <img :src="icoNotifyDanger" alt="ico danger" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea anular la factura?
        </h4>

        <p class="text-color-primary">
          Para completar todo el proceso de anulación la factura debe ser
          anulada en el
          <LinkSRI />
        </p>

        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="toggleModalInvoiceNuled"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Anular"
            @onSaveClick="onInvoiceNuled"
          />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="35%"
      title=""
      :visible.sync="invoiceDeleteOuterVisible"
      class=""
    >
      <div class="wrapper__invoice-delete text-center">
        <img :src="icoNotifyDanger" alt="ico danger" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea eliminar la factura?
        </h4>

        <p class="text-color-primary text-break">
          Recuerde que solo puede eliminar las facturas en borrador.
        </p>

        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="toggleModalInvoiceDelete"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Eliminar"
            @onSaveClick="onInvoiceDelete"
          />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="invoiceReactivateVisible"
      append-to-body
      custom-class="confirm-modal"
    >
      <div class="text-center">
        <i
          class="el-icon-refresh-right"
          style="font-size:30px;color:#3ecfb4;"
        ></i>
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Reactivar esta factura?
        </h4>
        <p class="text-color-primary">
          La factura volverá al estado <strong>Aprobada</strong> y podrá ser
          utilizada normalmente.
        </p>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="invoiceReactivateVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Reactivar"
            @onSaveClick="onInvoiceReactivate"
          />
        </div>
      </div>
    </el-dialog>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="onCloseDocumentSendDrawer"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="invoice && invoice.client ? invoice.client.id : null"
      :recipientName="invoice && invoice.client ? invoice.client.name : ''"
      :messageableType="'invoice'"
      :messageableId="$route.params.id"
      :moduleType="'invoice'"
      :isLoadingConfigTexts="false"
      :defaultMessage="invoiceDefaultMessage"
      :draftKey="'draft-invoice-' + $route.params.id"
    />

    <DocumentSendEmailHistory
      @onCloseDrawer="onCloseDocumentSendEmailHistory"
      :visibleDocumentHistoryEmail="visibleDocumentHistoryEmail"
      :emails="invoice.traking_history_emails"
    />

    <PaymentModal
      v-if="visibleAddPayment && invoice"
      :invoice="invoice"
      :open-tab="paymentModalTab"
      @close="visibleAddPayment = false"
      @payment-registered="onPaymentRegistered"
    />
  </div>
</template>

<script>
import BusinessLogo from "@/components/Business/BusinessLogo";
import AlertInfoComponent from "@/components/Alerts/Info";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import invoiceService from "../services/invoiceService";
import { signInvoiceSRI } from "../services/signInvoiceSRI";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import DocumentViewHeader from "../../../components/DocumentViewHeader";
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import DocumentCalculator from "../../../components/DocumentCalculator";
import DocumentSendEmailHistory from "../../../components/DocumentSendEmailHistory";
import PrintInvoice from "../components/PrintInvoice.vue";
import InvoiceTimeline from "../components/InvoiceTimeline.vue";
import PaymentModal from "../../projects/components/PaymentModal.vue";
import LinkSRI from "@/components/General/LinkSRI";
import SigningConfirmModal from "@/components/General/SigningConfirmModal";
import { limitCredits } from "../../quotes/assets/resources";

import { parseFloatFormat } from "@/assets/utils/format";
import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend,
  iconHistory,
  iconDownload,
  iconCheck
} from "@/services/resources";
import { downloadFile } from "@/assets/utils/files";
import { signingEventBus } from "@/services/signingEventBus";

export default {
  name: "InvoiceViewPage",
  data: () => ({
    limitCredits,
    icoNotifyDanger,
    iconEdit,
    iconDelete,
    iconNuled,
    iconSend,
    iconHistory,
    iconDownload,
    iconCheck,
    invoiceSRIOuterVisible: false,
    invoiceNuledOuterVisible: false,
    invoiceDeleteOuterVisible: false,
    invoiceReactivateVisible: false,
    visibleDocumentSend: false,
    visibleDocumentHistoryEmail: false,
    visibleAddPayment: false,
    paymentModalTab: null,
    invoice: null,
    installments: [],
    invoicePrint: false
  }),
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    },
    toMails() {
      const { client } = this.invoice;
      if (client && client.email) return [client.email];
      return [];
    },
    toPhone() {
      const { client } = this.invoice;
      return client && client.phone ? String(client.phone).trim() : "";
    },
    textOptionIsPaid() {
      const { is_paid } = this.invoice;
      return is_paid ? "Desmarcar" : "Marcar";
    },
    getLimitCredit() {
      return limitCredits.find(
        limit => this.invoice.limit_credit === limit.value
      );
    },
    invoiceDefaultMessage() {
      const name = this.invoice?.client?.name || "";
      const number = this.invoice?.number_invoice || "";
      return `Hola ${name},\n\nSe ha emitido una factura electrónica bajo el Nº- ${number}.\n\nAdjunto encontrarás el PDF y XML de tu factura.\n\nCualquier consulta, con gusto te atiendo.`;
    },
    reminderDetailText() {
      const next = this.invoice.next_reminder_at;
      if (!next) return "Recordatorios de cobro activos";
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const nextDate = new Date(next + "T00:00:00");
      const diffMs = nextDate - today;
      const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
      const formatted = this.formatFullDate(next);
      if (diffDays === 0) return "Próximo recordatorio: hoy";
      if (diffDays === 1) return "Próximo recordatorio: mañana";
      if (diffDays < 0) return "Recordatorios de cobro activos";
      return `Próximo recordatorio: ${formatted} (${diffDays} días)`;
    }
  },
  methods: {
    formatFullDate(date) {
      if (!date) return "";
      const normalized = /^\d{4}-\d{2}-\d{2}$/.test(date) ? date + "T00:00:00" : date;
      const d = new Date(normalized);
      const months = [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ];
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    humanizePaymentForm(title) {
      if (!title) return "";
      const map = {
        "OTROS CON UTILIZACION DEL SISTEMA FINANCIERO":
          "Transferencia bancaria",
        "SIN UTILIZACION DEL SISTEMA FINANCIERO": "Efectivo",
        "COMPENSACIÓN DE DEUDAS": "Compensación de deudas",
        "TARJETA DE DÉBITO": "Tarjeta de débito",
        "TARJETA DE CRÉDITO": "Tarjeta de crédito",
        "DINERO ELECTRÓNICO": "Dinero electrónico",
        "TARJETA PREPAGO": "Tarjeta prepago",
        "ENDOSO DE TÍTULOS": "Endoso de títulos"
      };
      return (
        map[title.toUpperCase()] ||
        title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()
      );
    },
    print() {
      const prtHtml = document.getElementById("printInvoice").innerHTML;

      /*  let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }
      console.log(stylesHtml) */
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <style>
                  body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";}
                  .d-flex { display: -ms-flexbox !important; display: -webkit-box !important; display: flex !important;}
                  .justify-content-center { -ms-flex-pack: center !important;  -webkit-box-pack: center !important; justify-content: center !important;}
                  .justify-content-between {  -ms-flex-pack: justify !important; -webkit-box-pack: justify !important; justify-content: space-between !important;}
                  .mt-4, .my-4 { margin-top: 1.5rem !important; }
                  .m-0 { margin: 0 !important; }
                  .m-2 { margin: 0.5rem !important; }
                  .mt-2, .my-2 { margin-top: 0.5rem !important; }
                  .font-semi-bold { font-weight: 600; }
                  h1, h2, h3, h4, h5, h6 { margin-top: 0; margin-bottom: 0.5rem; }
                  .font-bold { font-weight: 700; }
                  p { margin: 0; }
                  .text-pre-wrap { white-space: pre-wrap; word-wrap: break-word; }
                  .access_key { font-size: 12px !important; }
            </style>
          </head>
          <body>
            <div id="dataPrint">
              ${prtHtml}
            </div>
          </body>
        </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    handleCalculateSubTotal(quantity, price) {
      return parseFloatFormat(quantity * price);
    },
    goPage(name) {
      this.$router.push({ name });
    },
    toogleModalInvoiceSRI() {
      this.invoiceSRIOuterVisible = !this.invoiceSRIOuterVisible;
    },
    async sendInvoiceSRI() {
      const invoiceId = this.invoice.id;
      const clientName = this.invoice.client ? this.invoice.client.name : "";
      const documentNumber = this.invoice.number_invoice || "";

      this.toogleModalInvoiceSRI();

      signingEventBus.$emit("signing:start", {
        id: invoiceId,
        clientName,
        documentNumber
      });

      try {
        const { success, message, data } = await signInvoiceSRI(invoiceId);
        if (success) {
          signingEventBus.$emit("signing:done", {
            id: invoiceId,
            clientName,
            documentNumber
          });
        } else {
          signingEventBus.$emit("signing:error", {
            id: invoiceId,
            message: message || "Error al firmar"
          });
        }
        if (data) this.invoice = data;
      } catch (error) {
        signingEventBus.$emit("signing:error", {
          id: invoiceId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al firmar"
        });
        return false;
      }
    },
    async getInvoice(invoiceId) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await invoiceService
          .getInvoceId(invoiceId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (response) {
          this.invoice = response.data.data;
          if (this.invoice.method_payment === 3) {
            this.loadInstallments(invoiceId);
          }
        }
      } catch (error) {
        return false;
      }
    },
    async loadInstallments(invoiceId) {
      try {
        const res = await invoiceService.getInstallments(invoiceId);
        if (res.data && res.data.success) {
          this.installments = res.data.data;
        }
      } catch {
        // silently fail
      }
    },
    async onInvoiceNuled() {
      try {
        this.$store.dispatch("toggleRequestLoading");
        const { id: invoiceId } = this.invoice;
        let response = await invoiceService
          .updateInvoiceStatus({
            user_business_invoice_id: invoiceId
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.toggleModalInvoiceNuled();
          });
        const { success, data, message } = response.data;
        if (success) {
          this.invoice = data;
          this.$notifications.success({
            message
          });
        }
      } catch (error) {
        return false;
      }
    },
    async onInvoiceDelete() {
      try {
        this.$store.dispatch("toggleRequestLoading");
        const { id: invoiceId } = this.invoice;
        let response = await invoiceService
          .deleteInvoceId(invoiceId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.toggleModalInvoiceDelete();
          });
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({
            message
          });
          this.goPage("sales.documents");
        }
      } catch (error) {
        return false;
      }
    },
    async toggleReminders(val) {
      try {
        await invoiceService.updateReminders(this.invoice.id, {
          enable_reminders: val
        });
        this.$notifications.success(
          val
            ? "Notificaciones de cobro activadas"
            : "Notificaciones de cobro desactivadas"
        );
      } catch (e) {
        this.invoice.enable_reminders = !val;
        this.$notifications.error("No se pudo actualizar las notificaciones");
      }
    },
    handleCommand(command) {
      switch (command) {
        case "invoice-nuled":
          this.toggleModalInvoiceNuled();
          break;
        case "invoice-edit":
          this.goPage("sales.invoices.edit", {
            id: this.invoice.id
          });
          break;
        case "invoice-send":
          this.visibleDocumentSend = true;
          break;
        case "invoice-history-email":
          this.visibleDocumentHistoryEmail = true;
          break;
        case "invoice-delete":
          this.toggleModalInvoiceDelete();
          break;
        case "invoice-download":
          this.invoiceDownload();
          break;
        case "invoice-add-payment":
          this.paymentModalTab = null;
          this.visibleAddPayment = true;
          break;
        case "invoice-edit-payments":
          this.paymentModalTab = "partial";
          this.visibleAddPayment = true;
          break;
        case "invoice-paid":
          this.invoicePaid();
          break;
        case "invoice-print":
          this.invoicePrint = true;
          break;
        case "invoice-reactivate":
          this.invoiceReactivateVisible = true;
          break;
      }
    },
    async onInvoiceReactivate() {
      try {
        this.$store.dispatch("toggleRequestLoading");
        const invoiceId = this.invoice.id;
        let response = await invoiceService
          .reactivateInvoice(invoiceId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.invoiceReactivateVisible = false;
          });
        const { success, data, message } = response.data;
        if (success) {
          this.invoice = data;
          this.$notifications.success({
            message: message || "Factura reactivada exitosamente"
          });
        }
      } catch (error) {
        return false;
      }
    },
    async invoicePaid() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { is_paid, id: invoiceId } = this.invoice;
        let response = await invoiceService
          .invoicePaid({
            user_business_invoice_id: invoiceId,
            is_paid: !is_paid
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, message, data } = response.data;
        if (success) {
          this.invoice = data;
          this.$notifications.success({
            message
          });
        }
      } catch (error) {
        return false;
      }
    },
    async invoiceDownload() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { number_invoice, id } = this.invoice;
        let response = await invoiceService
          .invoiceDownload({
            id
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { data } = response;
        if (data) {
          downloadFile(data, `Factura - #${number_invoice}`);
        }
      } catch (error) {
        return false;
      }
    },
    async sendInvoiceEmail({ data }) {
      const emailId = `email-invoice-${Date.now()}`;
      const clientName = this.invoice?.client?.name || "";
      const docNumber = this.invoice?.number_invoice || "";

      this.visibleDocumentSend = false;

      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName,
        documentNumber: `Factura #${docNumber}`
      });

      try {
        let response = await invoiceService.sendInvoiceEmail({ data });
        const { success, message } = response.data;
        if (success) {
          signingEventBus.$emit("email:done", {
            id: emailId,
            clientName,
            documentNumber: `Factura #${docNumber}`
          });
        } else {
          signingEventBus.$emit("email:error", {
            id: emailId,
            message: message || "Error al enviar el documento"
          });
        }
      } catch (error) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al enviar"
        });
      }
    },
    toggleModalInvoiceNuled() {
      this.invoiceNuledOuterVisible = !this.invoiceNuledOuterVisible;
    },
    toggleModalInvoiceDelete() {
      this.invoiceDeleteOuterVisible = !this.invoiceDeleteOuterVisible;
    },
    onCloseDocumentSendDrawer() {
      this.visibleDocumentSend = false;
    },
    onCloseDocumentSendEmailHistory() {
      this.visibleDocumentHistoryEmail = false;
    },
    onDocumentSend({ data }) {
      data.append("invoice_id", this.invoice.id);
      this.sendInvoiceEmail({ data });
    },
    onPaymentRegistered() {
      this.getInvoice(this.invoice.id);
    }
  },
  components: {
    TopBarTitleComponent,
    AlertInfoComponent,
    ButtonPrimaryComponent,
    StatusReadDocumentsComponent,
    WrapperSendDocumentDrawer,
    DocumentCalculator,
    DocumentSendEmailHistory,
    BusinessLogo,
    PrintInvoice,
    InvoiceTimeline,
    LinkSRI,
    DocumentViewHeader,
    SigningConfirmModal,
    PaymentModal
  },
  mounted() {
    const { id: invoiceId } = this.$route.params;
    if (invoiceId) {
      this.getInvoice(invoiceId);
    }
  }
};
</script>

<style lang="scss" scoped>
.topbar-action-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #31355c;
  transition: all 0.15s;
  margin-right: 4px;

  &:hover {
    background: #f0f2f7;
  }
}
.topbar-action-btn--reminder-on {
  color: #3ecfb4 !important;
  &:hover {
    background: #f0fdfb !important;
  }
}
.reminder-next-text {
  color: #e07b00;
  font-weight: 600;
  font-size: 13px;
  .el-icon-bell {
    font-size: 13px;
  }
}
.card-quotes-view {
  border-radius: 14px;
  border: 1px solid #e8ecf2;
  box-shadow: 0 2px 12px rgba(49, 53, 92, 0.06);

  .card-quotes-view-header {
    .dvh-desktop {
      padding: 0;
    }
    .dvh-desktop-top {
      display: flex;
      gap: 32px;
      padding: 8px 0 12px;
    }
    .dvh-desktop-identity {
      display: flex;
      align-items: center;
      gap: 24px;
      flex: 1;
    }
    .dvh-desktop-logo {
      flex-shrink: 0;

      img {
        max-height: 60px;
        max-width: 180px;
        object-fit: contain;
        display: block;
        border-radius: 8px;
      }
    }
    .dvh-desktop-identity-info {
      flex: 1;
    }
    .dvh-desktop-sri-col {
      flex: 1;
      border-left: 1px solid rgba(0, 0, 0, 0.06);
      padding-left: 32px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .dvh-desktop-sri-title {
      font-size: 13px;
      font-weight: 600;
      color: #31355c;
      margin: 0;
    }
    .dvh-desktop-doc-number {
      font-size: 16px;
      font-weight: 500;
      color: #31355c;
      margin: 0 0 2px;
    }
    .dvh-desktop-business-name {
      font-size: 13px;
      color: #6b7280;
      margin: 0 0 2px;
    }
    .dvh-desktop-business-detail {
      font-size: 12px;
      color: #6b7280;
      margin: 0;
    }
    .dvh-desktop-divider {
      border: none;
      border-bottom: 1px solid #e8ecf1;
      margin: 16px 0;
    }
    .dvh-desktop-meta-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 16px 24px;
      padding: 4px 0;
    }
    .dvh-desktop-meta-cell {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
    .dvh-desktop-label {
      font-size: 11px;
      color: #9ca3af;
      display: block;
    }
    .dvh-desktop-value {
      font-size: 14px;
      font-weight: 600;
      color: #31355c;
    }
    // SRI styles
    .dvh-desktop-sri-body {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .dvh-desktop-sri-row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 3px;
    }
    .dvh-desktop-sri-code {
      font-size: 11px;
      font-family: monospace;
      word-break: break-all;
      color: #6b7280;
      line-height: 1.5;
    }
    .dvh-desktop-sri-env {
      font-size: 12px;
      font-weight: 600;
      padding: 2px 8px;
      border-radius: 10px;
      display: inline-block;
      &.env-prod {
        background: #e4fff4;
        color: #1d9e75;
      }
      &.env-dev {
        background: #fff8e6;
        color: #ba7517;
      }
    }
  }

  .card-quotes-view-body-products {
    min-height: 200px;

    .table-items {
      overflow-x: hidden;
    }
    .table-items-header {
      min-width: 0;
    }

    p {
      color: #31355c;
      font-size: 13px;
    }
    strong {
      color: #31355c;
      font-weight: 700;
      font-size: 14px;
    }
    .text-muted {
      color: #6b7280 !important;
      font-size: 12px;
    }
  }

  .card-quotes-view-aditionals {
    border-radius: 10px;
    border: 1px solid #e8ecf2;
    background: #f9fafb !important;

    p.font-semi-bold {
      color: #31355c;
      font-size: 13px;
      font-weight: 600;
    }
  }

  .card-quotes-view-method-pay {
    border-radius: 10px;
    border: 1px solid #e8ecf2;
    background: #fff;

    p.font-semi-bold {
      color: #31355c;
      font-weight: 600;
      font-size: 13px;
    }
    p.m-0:not(.font-semi-bold) {
      color: #31355c;
      font-weight: 600;
      font-size: 14px;
    }
  }
}

.doc-mobile-items {
  padding: 0;
}
.doc-mobile-item {
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  &:last-child {
    border-bottom: none;
  }
}
.doc-mobile-item-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.doc-mobile-name {
  font-size: 15px;
  font-weight: 600;
  color: #31355c;
  flex: 1;
  line-height: 1.4;
}
.doc-mobile-price {
  font-size: 15px;
  font-weight: 600;
  color: #31355c;
  white-space: nowrap;
}
.doc-mobile-meta {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}
.doc-mobile-detail {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
  line-height: 1.5;
}

@media (max-width: 767px) {
  .card-quotes-view {
    border-radius: 0;
    border-left: none;
    border-right: none;
    padding: 0 !important;
    .card-body {
      padding: 20px 16px;
    }
  }
}

// Installments view
.installments-view {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.inst-view-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #f7f8f9;
  border-radius: 8px;
  border: 1px solid #e4eaf6;
  &.inst-paid {
    background: #f0faf5;
    border-color: #c8ede0;
  }
}
.inst-view-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}
.inst-view-label {
  font-weight: 600;
  font-size: 13px;
  color: #31355c;
}
.inst-view-pct {
  font-size: 12px;
  color: #909399;
  background: #eef0f5;
  padding: 1px 6px;
  border-radius: 4px;
}
.inst-view-amount {
  font-weight: 600;
  font-size: 14px;
  color: #31355c;
}
.inst-view-status {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  &.status-paid {
    background: #e6f9f0;
    color: #1d9e75;
  }
  &.status-pending {
    background: #fff3e0;
    color: #e6a23c;
  }
}
</style>
